module.exports = "images/doc-program-print-2.98bb6e242d20d47aa0cf68932b828c22.png";